export default __webpack_public_path__ + "static/avant-guard-2590092a2bf3674bf03357278b568846.png";